import { Components } from '@formio/js';

/** Minimal Form.io field surface shared by custom components that host Angular widgets. */
export interface FormioAngularHostBase<TOptions extends object> {
  options: TOptions;
  refs: Record<string, HTMLElement | undefined>;
  readonly builderMode: boolean;
  render(children?: string): string;
  attach(element: HTMLElement): Promise<void>;
  redraw(): Promise<void>;
  destroy(...args: unknown[]): void;
  loadRefs(element: HTMLElement, refs: Record<string, string>): void;
}

type FormioAngularHostCtor<TOptions extends object> = {
  new (...args: unknown[]): FormioAngularHostBase<TOptions>;
  schema(...sources: unknown[]): Record<string, unknown>;
};

/** Form.io's plain-JS field base has no shipped type, so describe its shared host surface once. */
export function formioFieldComponent<TOptions extends object>(): FormioAngularHostCtor<TOptions> {
  return (Components as unknown as { components: Record<string, FormioAngularHostCtor<TOptions>> }).components.field;
}

/** Apply an Angular component's named inputs without coupling bridge helpers to ComponentRef. */
export function applyAngularHostInputs(
  ref: { setInput(name: string, value: unknown): void },
  inputs: Record<string, unknown>
): void {
  for (const [name, value] of Object.entries(inputs)) ref.setInput(name, value);
}
